import React from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import Navigation from '@App/navigation'
import { MemberSummary } from '@Entities/member/member-summary'

interface RightsholderSummaryCardProps {
    rightsHolderInfo: MemberSummary
}

const RightsholderSummaryCard = (props: RightsholderSummaryCardProps) => {
    const { name, totalWorks, registrationInProgress, teamMembers, ipId } = props.rightsHolderInfo

    return (
        <div className="rightsholder-summary-card-wrapper">
            <div className="name-block">
                <h4 title={name}>{name} Summary</h4>
            </div>
            <div className="info-line">
                <div>
                    <h1 className="blue-text">{totalWorks.toLocaleString()}</h1>
                    <p className="small">Total Works</p>
                </div>
                <div>
                    <h1 className="blue-text">{registrationInProgress}</h1>
                    <p className="small">Registration Drafts</p>
                </div>
                <div>
                    <h1 className="blue-text">{teamMembers}</h1>
                    <p className="small">Team Members</p>
                </div>
            </div>
            <Button
                typeLink
                linkTo={Navigation.rightholder.summary(ipId)}
                mainColor
                type="primary"
                icon={ICONS.arrow_forward}
            >
                View Member
            </Button>
        </div>
    )
}

export default RightsholderSummaryCard
